import React from 'react';

import { useAreaUnits } from '$contexts/area-units';
import BaseSelect from '$partials/fields/select.jsx';
import { usePersistedCookieState } from '$utilities/data';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').AreaUnitsSelector}
 */
const AreaUnitsSelector = ({
    className
}) => {
    const { unit, setUnit } = useAreaUnits() || {};

    const firstPathSegment = (typeof window !== 'undefined' ? window.location.pathname.split('/').filter(Boolean)[0] : '') || '';
    const { setValue: setUnitCookie } = usePersistedCookieState('sqft', `${firstPathSegment}_area_unit_cookie`);

    const areaOptions = [
        { label: 'sqm', value: 'sqm' },
        { label: 'sqft', value: 'sqft' },
    ];

    return (
        <BaseSelect
            displayValue={areaOptions.find((opt) => opt.value === unit)?.label}
            name='area-unit'
            onChange={(selectedUnit) => {
                setUnit(/** @type {import('$types/components/contexts').AreaUnit} */ (selectedUnit));
                setUnitCookie(selectedUnit);
            }}
            options={areaOptions}
            triggerClassName={className}
            value={unit} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default AreaUnitsSelector;
